/* سجلّ أخطاء بسيط: يلتقط أخطاء window / الوعود / console.error */
const _log = [];
const _subs = new Set();
const safe = (x) => { try { if (x instanceof Error) return x.message + (x.stack ? " | " + String(x.stack).split("\n")[1] : ""); if (x && typeof x === "object" && (x.message || x.code || x.details)) return [x.code, x.message, x.details].filter(Boolean).join(" | "); return typeof x === "string" ? x : JSON.stringify(x); } catch { return String(x); } };
function persist() {
  try { localStorage.setItem("tpms_errlog", JSON.stringify(_log.slice(0, 50))); } catch {}
}
function restore() {
  try { const r = JSON.parse(localStorage.getItem("tpms_errlog") || "[]"); if (Array.isArray(r)) _log.push(...r); } catch {}
}
function push(type, msg, extra) {
  _log.unshift({ id: Date.now() + "-" + Math.random().toString(36).slice(2, 6), type, msg: String(msg ?? ""), extra: extra ? String(extra) : "", at: new Date().toLocaleTimeString("ar-KW") });
  if (_log.length > 200) _log.pop();
  persist();
  try { cloudQueue(_log[0]); } catch {}
  _subs.forEach((f) => { try { f(); } catch {} });
}
export const logError = (msg, extra) => push("error", msg, extra);
export const getLog = () => _log;
export const clearLog = () => { _log.length = 0; try { localStorage.removeItem("tpms_errlog"); } catch {} _subs.forEach((f) => f()); };
export const copyLog = () => {
  const txt = _log.map((e) => `[${e.at}] ${e.type}: ${e.msg}${e.extra ? " @ " + e.extra : ""}`).join("\n");
  try { navigator.clipboard.writeText(txt); } catch {}
  return txt;
};
export const subscribe = (f) => { _subs.add(f); return () => _subs.delete(f); };

/* ═══ رفع سحابي مخنوق: دفعة كل 30 ثانية كحد أقصى ═══ */
let _pending = [];
let _flushTimer = null;
async function cloudFlush() {
  _flushTimer = null;
  const batch = _pending.splice(0, 20);
  if (!batch.length) return;
  try {
    const { supabase } = await import("./supabaseClient.js");
    const { data: u } = await supabase.auth.getUser();
    if (!u || !u.user) return;
    const device = /Mobi|Android/i.test(navigator.userAgent) ? "جوال" : "حاسوب";
    await supabase.from("error_logs").insert(batch.map(e => ({ user_id: u.user.id, device, type: e.type, msg: String(e.msg).slice(0, 500), extra: String(e.extra || "").slice(0, 200) })));
  } catch {}
}
function cloudQueue(e) {
  if (e.type === "info") return;
  _pending.push(e);
  if (!_flushTimer) _flushTimer = setTimeout(cloudFlush, 30000);
}

export function initErrorCapture() {
  if (typeof window === "undefined" || window.__tpmsErr) return;
  window.__tpmsErr = true;
  restore();
  window.addEventListener("error", (e) => push("error", e.message || "خطأ", (e.filename || "") + (e.lineno ? ":" + e.lineno : "")));
  window.addEventListener("unhandledrejection", (e) => push("promise", (e.reason && e.reason.message) || safe(e.reason)));
  const orig = console.error.bind(console);
  console.error = (...a) => { push("console", a.map(safe).join(" ")); orig(...a); };
  push("info", "بدأ سجلّ الأخطاء");
}
